import React from 'react';
import { SalesHero } from '../components/SalesHero';
import { PainPoints } from '../components/PainPoints';
import { ProductReveal } from '../components/ProductReveal';
import { FourPockets } from '../components/FourPockets';
import { WeeklyClose } from '../components/WeeklyClose';
import { WhatYouGet } from '../components/WhatYouGet';
import { Objections } from '../components/Objections';
import { Pricing } from '../components/Pricing';
import { SalesFooter } from '../components/SalesFooter';
import { SalesNotification } from '../components/SalesNotification';
export function SalesPage() {
  return <main className="min-h-screen w-full overflow-x-hidden" data-id="element-217">
      <SalesHero data-id="element-218" />
      <PainPoints data-id="element-219" />
      <ProductReveal data-id="element-220" />
      <FourPockets data-id="element-221" />
      <WeeklyClose data-id="element-222" />
      <WhatYouGet data-id="element-223" />
      <Objections data-id="element-224" />
      <Pricing data-id="element-225" />
      <SalesFooter data-id="element-226" />
      <SalesNotification data-id="element-227" />
    </main>;
}